module.exports = __webpack_public_path__ + "img/logo-home.fed09f99.png";